<template>
  <div>
    <p class="text-queue-next">
      {{ $t("IdentityQueueNext.p.upNext") }}
      <span>
        {{ nextStep }}
      </span>
    </p>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useIdentityQueueStore } from '@/stores/identityQueueStore';

const identityQueueStore = useIdentityQueueStore();
const route = useRoute();
const { t } = useI18n();

const nextStep = computed(() => {
  if (identityQueueStore.requiresDocRecollection
    && identityQueueStore.identityRoutes.length - 1 <= 0
  ) {
    return t('IdentityQueueNext.p.orderStatus');
  }

  if (
    identityQueueStore.identityRoutes.length <= 0
    || identityQueueStore.queueCounter === identityQueueStore.totalSteps
    || identityQueueStore.requiresDocRecollection
  ) {
    return t('IdentityQueueNext.p.payment');
  }

  if (identityQueueStore.queueCounter < identityQueueStore.totalSteps) {
    return identityQueueStore.identityRoutes[identityQueueStore.queueCounter]
      ?.name;
  }

  return t('IdentityQueueNext.p.payment');
});
</script>

<style lang="scss" scoped>
.text-queue {
  &-next {
    text-align: center;
    padding-top: $padding-sml;
    span {
      opacity: 0.7;
    }
  }
}
</style>
